import { ICommonList } from '@/interfaces/common.interface';
import { svgIcons } from '../UI/SvgIcons';
import FilterButtons from './FilterTabs';
import { useState } from 'react';
import FormField from '../UI/FormField';

const { SearchIcon, CrossIcon } = svgIcons;

interface ICommonFilters {
  activeFilter?: string;
  filters?: ICommonList[];
  onChange?: (filter: string) => void;
  searchValue?: string;
  inputPlaceHolder?: string;
  onSearch?: (text: string) => void;
  filterOptions?: filterOption;
  showSearch?: boolean;
}

interface filterOption {
  values: { value: string; label: string }[];
  onChange: (value: string) => void;
}

const CommonFilter: React.FC<ICommonFilters> = ({
  activeFilter,
  filters,
  onChange,
  inputPlaceHolder,
  onSearch,
  filterOptions,
  showSearch = true,
  searchValue,
}) => {
  const [states, setStates] = useState({
    isSearchClick: false,
    searchText: searchValue,
  });

  const handleChangeState = (newState: Partial<typeof states>) => {
    setStates((prev) => ({ ...prev, ...newState }));
  };

  return (
    <div className="flex justify-between items-center gap-4 flex-wrap xl:flex-nowrap w-full">
      {/* Tabs */}
      {filters?.length && (
        <FilterButtons
          active={activeFilter}
          filters={filters}
          onChange={onChange}
        />
      )}

      {/* Spacer (THIS is the key trick) */}
      {/* <div className="hidden lg:block flex-1" /> */}

      {/* Controls */}
      <div className="flex items-center gap-3">
        {/* Search */}
        {(states.isSearchClick || states.searchText) && (
          <div>
            <FormField
              placeholder={inputPlaceHolder}
              type="text"
              autoFocus
              value={states.searchText}
              onChange={(e) => {
                const value = e.target.value;
                handleChangeState({ searchText: value });
                onSearch?.(value);
              }}
            />
          </div>
        )}

        {showSearch && (
          <button
            type="button"
            onClick={() => {
              handleChangeState({
                isSearchClick: !states.isSearchClick,
                searchText: '',
              });
              onSearch?.('');
            }}
          >
            {states.isSearchClick || states.searchText ? CrossIcon : SearchIcon}
          </button>
        )}

        {/* Select */}
        {filterOptions && (
          <div className="w-44">
            <FormField
              type="select"
              options={filterOptions.values}
              placeholder="Select Type"
              onChange={(e) => filterOptions.onChange(e.target.value)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonFilter;
